// src/views/writing/RulesOfTheGame.tsx
// eslint-disable-next-line react/react-in-jsx-scope
import React from 'react';
import GameRulesText from '../../components/InfoButton/GameRulesText';

const RulesOfTheGame = () => (
  <>
    <p style={{ color: 'darkslategray', margin: '0' }}>
      <GameRulesText game="writing" />
    </p>
  </>
);

export default RulesOfTheGame;
